import(/* webpackMode: "eager" */ "/var/www/deemcee-frontend/src/app/global-error.tsx");
